export enum MessageType {
  Success = '-success',
  Info = '-info',
  SuccessOutline = '-success-outlined',
}

export interface Message {
  title?: string;
  text: string;
  type: MessageType;
}